module.exports = __webpack_public_path__ + "static/replicad-3118a05bde8bbf63f5f3e6fed7ec0875.png";